<template>
  <modal-wrapper
    ref="modalRef"
    :content-overflow-y="'auto'"
    :display-cancel-button="false"
    :size="ModalSize.XL"
    @hide="resetModal"
  >
    <kks-vgbm-form-container
      ref="kksVgbmFormContainerRef"
      :kks-id-prop="props.kksId"
    />
  </modal-wrapper>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import KksVgbmFormContainer from '@/components/KksVgbmFormContainer/KksVgbmFormContainer.vue';
  import { ModalSize } from '../ModalWrapper/ModalWrapper.types';
  import { useModalWrapper } from '../ModalWrapper';

  const props = defineProps<{ kksId: string }>();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });

  const kksVgbmFormContainerRef = ref<InstanceType<
    typeof KksVgbmFormContainer
  > | null>(null);
  function resetModal(): void {
    kksVgbmFormContainerRef.value?.resetForm();
  }
</script>
